import { useIsVirtualBackgroundEnabled } from './useIsVirtualBackgroundEnabled';
import { getVirtualBackgroundFromLocalStorage } from '../../components/media/virtualBackground';
import { useGetUserId } from '../../hooks/useCredentials';
import { useAllVirtualBackgrounds } from './useAllVirtualBackgrounds';

export const useVirtualBackgroundName = (): string | null => {
  const userId = useGetUserId();
  const isVirtualBgEnabled = useIsVirtualBackgroundEnabled();
  const allVirtualBackgrounds = useAllVirtualBackgrounds();

  const storedBackground =
    Boolean(userId) &&
    getVirtualBackgroundFromLocalStorage(userId, allVirtualBackgrounds);

  if (!isVirtualBgEnabled || !storedBackground) {
    return null;
  }

  return storedBackground.name === 'None' ? null : storedBackground.name;
};
